export default __webpack_public_path__ + "static/media/Oxford.cc25a46d.png";